import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NavbarComponent } from './components/navbar/navbar.component';
import { AuthComponent } from './pages/auth/auth.component';
import { HomeDarkComponent } from './module/web_dark/pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { TimelineComponent } from './pages/timeline/timeline.component';
import { WorkComponent } from './pages/work/work.component';
import { StoryComponent } from './pages/story/story.component';
import { AddProjectsComponent } from './pages/admin/add-projects/add-projects.component';
import { DataHireComponent } from './components/home/data-hire/data-hire.component';
import { ProjectDetailComponent } from './components/project/project-detail/project-detail.component';
import { AddWorkComponent } from './pages/work/add-work/add-work.component';
import { VerifyComponent } from './pages/auth/verify/verify.component';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { AutocompleteMapComponent } from './pages/autocomplete-map/autocomplete-map.component';
import { PlacesComponent } from './pages/places/places.component';
import { HomeComponent } from './components/home/home.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'login',
    component: AuthComponent
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'story',
    component: StoryComponent
  },
  {
    path: 'timeline',
    component: TimelineComponent
  },
  {
    path: 'work',
    component: WorkComponent
  },
  {
    path: 'add-project/:id',
    component: AddProjectsComponent
  },
  {
    path: 'places',
    component: PlacesComponent
  },
  {
    path: 'add-project',
    loadChildren: async () => (await import('./pages/admin/admin-routing.module')).AdminRoutingModule
  },
  {
    path: 'data-hire',
    component: DataHireComponent
  },
  {
    path: 'project-detail/:id',
    component: ProjectDetailComponent
  },
  {
    path: 'work/add-work',
    component: AddWorkComponent
  },
  {
    path: 'verify',
    component: VerifyComponent
  },
  {
    path: '404',
    component: ForbiddenComponent
  },
  // {
  //   path: 'web-dark',
  //   loadChildren: async () => (await import('./module/web_dark/pages/home/home-routing.module')).HomeRoutingModule
  // }
  {
    path: 'web-dark/:dark',
    component: HomeDarkComponent
    // loadChildren: () => import('./module/web_dark/pages/home/home.component').then(m => m.HomeDarkComponent)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
